<template>
  <vs-sidebar
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="sidebarConfig.isOpen"
    id="sidebar-right"
  >
    <div v-if="sidebarConfig.type == 'staff'">
      <div class="header-sidebar text-center p-4">
        <h3 class="font-extrabold p-3">Staffs List of {{sidebarConfig.checkin_info.checkin_name}}</h3>
        <div>{{sidebarConfig.checkin_info.checkin_at}}</div>
      </div>

      <div v-for="staff in sidebarData.staffs" :key="staff.user_id">
        <sidebar-item :item="staff"></sidebar-item>
      </div>
    </div>

    <div v-else>
      <div class="header-sidebar text-center p-4">
        <h3 class="font-extrabold p-3">Services List of {{sidebarConfig.checkin_info.checkin_name}}</h3>
        <div>{{sidebarConfig.checkin_info.checkin_at}}</div>
      </div>

      <div v-for="service in sidebarData.services" :key="service.id">
        <sidebar-item :item="service"></sidebar-item>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  name: "vs-sidebar-right",
  components: {
    SideBarItem: () => import("../components/SideBarItem.vue")
  },
  props: {
    sidebarConfig: {
      type: Object,
      required: true
    },
    sidebarData: {
      type: Object,
      required: true
    }
  }
};
</script>